<script lang="ts">
  import { page } from "$app/stores";
  import LogOut from "./icons/LogOut.svelte";
</script>

<div class="user_menu">
  <a href="/members"> Dashboard </a>
  <a href="/members/profile"> Edit Profile </a>
  {#if $page.data.user?.enable_public_page && $page.data.user?.handle}
    <a href="/community/{$page.data.user.handle}"> My Public Page</a>
  {/if}
  <a href="/members/settings">Account Settings</a>
  <a href="/members/subscription">My Subscription</a>
  <a href="/members/inbox">Messaging & Inbox</a>
  <a href="/logout" class="logout">
    Logout
    <LogOut size={10} color="white" />
  </a>
</div>

<style>
  .user_menu {
    font-size: 0.8rem;
    display: flex;
    flex-flow: column;
    width: 100%;
  }
  .user_menu a {
    text-decoration: none;
    font-family: var(--font);
    color: var(--title);
    padding: 0.5rem;
  }
  .user_menu .logout {
    margin-top: 0.25rem;
    color: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    border-radius: 0.25rem;
    background: var(--secondary);
    font-weight: bold;
  }
</style>
